"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountIdentityDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class AccountIdentityDto {}
exports.AccountIdentityDto = AccountIdentityDto;
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.IdentityProvider
}), __metadata("design:type", String)], AccountIdentityDto.prototype, "provider", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Provider subject (Google/Apple sub, or E.164 telephone for Telephone)',
  nullable: true
}), __metadata("design:type", Object)], AccountIdentityDto.prototype, "providerSubject", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], AccountIdentityDto.prototype, "email", void 0);
//# sourceMappingURL=AccountIdentity.dto.js.map